import {
  Autocomplete as AutocompleteMUI,
  SxProps,
  Theme,
  UseAutocompleteProps,
} from "@mui/material";
import TextField from "../atoms/TextField";

interface AutoCompleteSearchProps<T> {
  options: T[];
  value: T | null;
  onChange?: (e: React.SyntheticEvent<Element, Event>, value: T | null) => void;
  label?: string;
  error?: boolean;
  sx?: SxProps<Theme>;
}

export const AutoCompleteSearch = <T,>(
  props: AutoCompleteSearchProps<T> &
    UseAutocompleteProps<T, undefined, undefined, undefined>
) => {
  const { options, value, onChange, label, sx, error, ...baseProps } = props;
  return (
    <AutocompleteMUI
      {...baseProps}
      disableClearable={true}
      options={options}
      autoHighlight
      defaultValue={undefined}
      value={value || undefined}
      onChange={(e, value) => {
        onChange && onChange(e, value);
      }}
      sx={{
        "& .MuiFormControl-root": {
          border: "0.5px solid #c4c4c4",
          borderRadius: "4px",
          height: "40px",
          "& .MuiFormLabel-root": {
            marginTop: "-11px",
            backgroundColor: "#fff",
            paddingLeft: "10px",
          },
          "& .MuiInputBase-root": {
            "& .MuiAutocomplete-endAdornment": {
              top: "50%",
              transform: "translateY(calc(-50% - 3px))",
              right: "8px",
            },
            marginTop: "6px",
            "::before": { borderBottom: "none" },
          },
        },
      }}
      key={JSON.stringify(value)}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            inputProps={{
              ...params.inputProps,
            }}
            sx={{ paddingLeft: 1, ...sx }}
            minWidth="100%"
            label={label}
            error={error}
          />
        );
      }}
    />
  );
};
